import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { takeUntil, withLatestFrom } from "rxjs/operators";
import { merge, Subject } from "rxjs";
import { MatterportViewerComponent } from "../matterport-viewer/matterport-viewer.component";
import { parseMattertagAssetLink } from "./mattertag-asset-link.model";
import { NgIf } from "@angular/common";
import { NbSpinnerModule } from "@nebular/theme";

@Component({
  selector: "ngx-matterport-page",
  templateUrl: "./matterport-page.component.html",
  styleUrls: ["./matterport-page.component.scss"],
  imports: [NgIf, NbSpinnerModule, MatterportViewerComponent],
})
export class MatterportPageComponent implements OnChanges, OnDestroy {
  @Input() matterportModelSid: string;
  public mattertagSelected$: Subject<string> = new Subject();
  public mattertagHovered$: Subject<string> = new Subject();
  public mattertagDocked$: Subject<string> = new Subject();
  public loading: boolean = true;
  private destroyed$ = new Subject<void>();

  @ViewChild("viewer", { static: false })
  private viewer: MatterportViewerComponent;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.matterportModelSid) {
      this.loading = true;
      setTimeout(() => (this.loading = false), 500);
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
  }

  public onMatterportConnected(): void {
    merge(this.mattertagSelected$, this.mattertagHovered$)
      .pipe(
        withLatestFrom(this.viewer.mattertagList$),
        takeUntil(this.destroyed$),
      )
      .subscribe(([mattertagSid, mattertagList]) => {
        if (!mattertagList) {
          return;
        }

        const mattertag = mattertagList.find((x) => x.id === mattertagSid);
        if (!mattertag) {
          return;
        }

        const mattertagAssetLink = parseMattertagAssetLink(mattertag);

        this.viewer
          .linkMattertagToHelix(mattertagAssetLink, mattertagSid)
          .then(() =>
            console.debug(
              "[MatterportPageComponent] Linked Mattertag with",
              mattertagAssetLink,
            ),
          );
      });
  }
}
